<script>
    import { _ } from 'svelte-i18n'

    let { onClick = () => {} } = $props();
</script>

<button class="btn btn-link text-decoration-none text-secondary" onclick={onClick}
    >{$_('payment.contact_me.message.link')}</button
>
